import { createContext, useContext, useState, useMemo } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

const themeColors = {
  blue: "#1976d2",
  black: "#000000",
  green: "#388e3c",
  purple: "#7b1fa2",
  orange: "#f57c00",
  // ❌ white: "#ffffff",  ← loại bỏ dòng này
};


const ThemeContext = createContext();

export const ThemeProviderWrapper = ({ children }) => {
  const [mode, setMode] = useState(localStorage.getItem("themeMode") || "light");
  const [primaryColor, setPrimaryColor] = useState(
    localStorage.getItem("themeColor") || themeColors.blue 
  );
  

  const toggleDarkMode = () => {
    const newMode = mode === "light" ? "dark" : "light";
    setMode(newMode);
    localStorage.setItem("themeMode", newMode);
  };

  const setPrimaryColorWithSave = (color) => {
    const safeColor = color === "#ffffff" ? "#1976d2" : color;
    setPrimaryColor(safeColor);
    localStorage.setItem("themeColor", safeColor);
  };
  

  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          primary: { main: primaryColor },
          background: {
            default: mode === "dark" ? "#121212" : "#fafafa", 
            paper: mode === "dark" ? "#1e1e1e" : "#fff",  
          },
          text: {
            primary: mode === "dark" ? "#fff" : "#000",
          },
        },
        components: {
          //Fix hiển thị Dialog trong cả light/dark
          MuiDialog: {
            styleOverrides: {
              paper: {
                backgroundColor: mode === "dark" ? "#1e1e1e" : "#ffffff",
                color: mode === "dark" ? "#ffffff" : "#000000",
              },
            },
          },
          MuiDialogTitle: {
            styleOverrides: {
              root: {
                color: mode === "dark" ? "#ffffff" : "#000000",
                fontWeight: "bold",
              },
            },
          },
          MuiDialogContentText: {
            styleOverrides: {
              root: {
                color: mode === "dark" ? "#eeeeee" : "#333333",
              },
            },
          },

          MuiOutlinedInput: {
            styleOverrides: {
              root: {
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#ccc",
                  transition: "border-color 0.2s ease-in-out",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1976d2",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderWidth: "2px",
                  borderColor: "#1976d2",
                },
                color: mode === "dark" ? "#fff" : "#000",
              },
            },
          },
          MuiCheckbox: {
            styleOverrides: {
              root: {
                color: primaryColor,
                "&.Mui-checked": {
                  color: primaryColor,
                },
              },
            },
          },
          MuiTextField: {
            defaultProps: {
              variant: "outlined",
            },
            styleOverrides: {
              root: {
                "& .MuiInputBase-input": {
                  color: mode === "dark" ? "#fff" : "#000",
                },
              },
            },
          },
        },
      }),
    [mode, primaryColor]
  );

  return (
    <ThemeContext.Provider
      value={{
        mode,
        toggleDarkMode,
        primaryColor,
        setPrimaryColor: setPrimaryColorWithSave,
      }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => useContext(ThemeContext);
